<template>
  <Row :gutter="10">
    <Col span="8">
      <Select v-model="province">
        <Option v-for="v in provinceList" :value="v.Id" :key="v.Id">{{ v.Name }}</Option>
      </Select>
    </Col>
    <Col span="8" v-if="cityList.length">
      <Select v-model="city">
        <Option v-for="v in cityList" :value="v.Id" :key="v.Id">{{ v.Name }}</Option>
      </Select>
    </Col>
    <Col span="8" v-if="regionList.length">
      <Select v-model="region">
        <Option v-for="v in regionList" :value="v.Id" :key="v.Id">{{ v.Name }}</Option>
      </Select>
    </Col>
  </Row>
</template>
<script>
/* 地区选择器 */
export default {
  data() {
    return {
      province: "",
      city: "",
      region: "",
      provinceList: [],
      cityList: [],
      regionList: [],
      dv:this.defaultValue
    };
  },
  props: ["defaultValue"],
  methods: {
    async getData(type, id) {
      this.$emit("change", "");
      let res = await this.$axios.get("/Member/RZJFund/Region", {
        params: {
          id
        }
      });
      if (res.err) return;
      let dv = this.dv;
      if (type == 0) {
        this.provinceList = res;
        this.province = dv && dv[0] ? dv[0] : "";
      } else if (type == 1) {
        this.cityList = res;
        this.city = dv && dv[1] ? dv[1] : "";
        if(dv && !dv[2]) this.dv=null
      } else if (type == 2) {
        this.regionList = res;
        this.region = dv && dv[2] ? dv[2] : "";
        this.dv=null
      }
    }
  },
  watch: {
    province(v) {
      this.city = "";
      this.cityList = [];
      if (!v) return;
      let list = this.provinceList.filter(x => x.Id == v);
      if (list.length && list[0].IsEnd) {
        this.$emit("change", v);
      } else {
        this.$emit("change", "");
        this.getData(1, v);
      }
    },
    city(v) {
      this.region = "";
      this.regionList = [];
      if (!v) return;
      let list = this.cityList.filter(x => x.Id == v);
      if (list.length && list[0].IsEnd) {
        this.$emit("change", v);
      } else {
        this.$emit("change", "");
        this.getData(2, v);
      }
    },
    region(v) {
      if (!v) return;
      this.$emit("change", v);
    }
  },
  computed: {},
  mounted() {
    this.getData(0, 0);
  }
};
</script>
<style lang="less" scoped>
</style>
